import type { CSSProperties, MouseEvent } from "react";
import { UnstyledButton } from "@mantine/core";
import { IconBookmark } from "@tabler/icons-react";

const CARD_NAVY = "#04305c";
const CARD_BLUE = "#2563EB";

type BookmarkVariant = "filled" | "outline";

const BOOKMARK_BTN_BASE: CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 42,
  flexShrink: 0,
  borderRadius: 12,
  transition: "all 0.2s ease",
};

const BOOKMARK_BTN_STYLES: Record<BookmarkVariant, CSSProperties> = {
  filled: {
    ...BOOKMARK_BTN_BASE,
    border: `1.5px solid ${CARD_NAVY}`,
    backgroundColor: CARD_NAVY,
    color: "#FFFFFF",
  },
  outline: {
    ...BOOKMARK_BTN_BASE,
    border: `1.5px solid ${CARD_BLUE}`,
    backgroundColor: "#FFFFFF",
    color: CARD_BLUE,
  },
};

type EcosystemHeadShortlistBookmarkButtonProps = {
  isShortlisted: boolean;
  onClick: () => void | Promise<void>;
  variant?: BookmarkVariant;
};

export default function EcosystemHeadShortlistBookmarkButton({
  isShortlisted,
  onClick,
  variant = "filled",
}: EcosystemHeadShortlistBookmarkButtonProps) {
  const label = isShortlisted ? "Remove from shortlist" : "Add to shortlist";
  const iconColor = variant === "outline" ? CARD_BLUE : "white";

  const handleClick = (e: MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    void onClick();
  };

  return (
    <UnstyledButton
      type="button"
      aria-label={label}
      title={label}
      onPointerDown={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
      onClick={handleClick}
      style={BOOKMARK_BTN_STYLES[variant]}
    >
      <IconBookmark size={18} color={iconColor} fill={isShortlisted ? "currentColor" : "none"} />
    </UnstyledButton>
  );
}
